import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mt-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  key: 0,
  class: "btn btn-primary",
  id: "kt_invoiceDiscountOfferPanel_toggle"
}
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  class: "accordion",
  id: "kt_accordion"
}
const _hoisted_7 = ["id"]
const _hoisted_8 = ["data-bs-target", "aria-controls"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "fs-5 me-5 min-w-150px" }
const _hoisted_11 = { class: "fs-5 badge badge-light-primary" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "fs-5 me-4" }
const _hoisted_15 = { class: "fs-5 badge badge-light-danger" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "fs-5 me-4" }
const _hoisted_18 = { class: "fs-5 badge badge-light-danger" }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "fs-5 me-4 min-w-150px" }
const _hoisted_21 = { class: "fs-5 badge badge-light-primary" }
const _hoisted_22 = ["id", "aria-labelledby"]
const _hoisted_23 = { class: "accordion-body" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-9" }
const _hoisted_26 = { class: "col-3" }
const _hoisted_27 = { class: "fw-bold mt-5" }
const _hoisted_28 = { class: "col-3" }
const _hoisted_29 = { class: "fw-bold mt-5" }
const _hoisted_30 = { class: "col-3" }
const _hoisted_31 = { class: "fw-bold mt-5" }
const _hoisted_32 = { class: "col-2" }
const _hoisted_33 = {
  key: 0,
  class: "fw-bold mt-5 badge-light-success fs-4"
}
const _hoisted_34 = { class: "col-3" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceDiscountOfferPanel = _resolveComponent("InvoiceDiscountOfferPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "card-title" }, [
          _createElementVNode("h3", null, "Offers")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.canAddOffer )
            ? (_openBlock(), _createElementBlock("button", _hoisted_4, "Add Offer"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice.InvoiceDiscountOffers, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "accordion-item",
              key: index
            }, [
              _createElementVNode("h2", {
                class: "accordion-header",
                id: 'kt_accordion_'+index+'_header_'+index
              }, [
                _createElementVNode("button", {
                  class: "accordion-button fw-bold collapsed",
                  type: "button",
                  "aria-expanded": "false",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": '#kt_accordion_'+index+'_body_'+index,
                  "aria-controls": 'kt_accordion_'+index+'_body_'+index
                }, [
                  _createElementVNode("span", {
                    class: "me-5 me-4 min-w-200px",
                    innerHTML: _ctx.getDiscountOfferStatusLabel(item.Status),
                    style: {"min-width":"10em"}
                  }, null, 8, _hoisted_9),
                  _createElementVNode("span", _hoisted_10, [
                    _cache[1] || (_cache[1] = _createTextVNode("Date: ", -1)),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.dateTimeFormat(item.Created)), 1)
                  ]),
                  (item.Status != _ctx.DiscountOfferStatus.DRAFT)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (item.Status === _ctx.DiscountOfferStatus.CANCELLED)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createElementVNode("span", _hoisted_14, [
                                _createTextVNode(_toDisplayString(_ctx.toTitleCase(_ctx.DiscountOfferStatus.CANCELLED)) + " ", 1),
                                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.dateTimeFormat(item.SubmittedToVendorDate,item.OfferExpirationDays)), 1)
                              ])
                            ]))
                          : (item.Status=== _ctx.DiscountOfferStatus.EXPIRED && item.Status === _ctx.DiscountOfferStatus.PENDING_APPROVAL)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("span", _hoisted_17, [
                                  _createTextVNode(_toDisplayString(_ctx.toTitleCase(_ctx.DiscountOfferStatus.EXPIRED)) + " ", 1),
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.expirationTimeFormat(item.SubmittedToVendorDate,item.OfferExpirationDays)), 1)
                                ])
                              ]))
                            : (item.Status === _ctx.DiscountOfferStatus.PENDING_APPROVAL)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createElementVNode("span", _hoisted_20, [
                                    _cache[2] || (_cache[2] = _createTextVNode("Expiration in ", -1)),
                                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.expirationDateTimeFormat(item.SubmittedToVendorDate,item.OfferExpirationDays)), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_8)
              ], 8, _hoisted_7),
              _createElementVNode("div", {
                id: 'kt_accordion_'+index+'_body_'+index,
                class: "accordion-collapse collapse",
                "aria-labelledby": 'kt_accordion_'+index+'_header_'+index,
                "data-bs-parent": '#kt_accordion'
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.InvoiceDiscountOfferOptions, (option, optIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "row mb-2",
                          key: optIndex
                        }, [
                          _createElementVNode("div", _hoisted_26, [
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-gray-600" }, "Payment Date - ", -1)),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.countSubmitedDate(option.PaymentPeriodInDays,item)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-gray-600" }, "Discount Percent - ", -1)),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_29, _toDisplayString(option.DiscountPercent.toTwoFractionDigits()) + " %", 1)
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-gray-600" }, "New Total Amount - ", -1)),
                            _cache[8] || (_cache[8] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.countNewTotalAmount(option.DiscountPercent)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            (option.IsAccepted)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Accepted"))
                              : _createCommentVNode("", true)
                          ]),
                          _cache[9] || (_cache[9] = _createElementVNode("hr", null, null, -1))
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      (item.Status === _ctx.DiscountOfferStatus.PENDING_APPROVAL)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.cancelOffer(item.Id)),
                            class: "btn btn-danger float-end"
                          }, " Cancel ", 8, _hoisted_35))
                        : _createCommentVNode("", true),
                      (item.Status === _ctx.DiscountOfferStatus.DRAFT)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.sendOfferForApproval(item.Id)),
                              class: "btn btn-warning float-end"
                            }, " Send ", 8, _hoisted_37),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.setUpdateOfferData(item.Id)),
                              class: "btn btn-primary me-4 float-end",
                              id: "kt_invoiceDiscountOfferPanel_toggle"
                            }, " Update ", 8, _hoisted_38)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ], 8, _hoisted_22)
            ]))
          }), 128))
        ]),
        (_ctx.invoice?.InvoiceDiscountOffers?.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("div", { class: "alert alert-danger p-5 text-center" }, [
                _createElementVNode("h4", { class: "mb-1 text-dark" }, "No Data")
              ], -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_InvoiceDiscountOfferPanel)
  ], 64))
}